import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { sortBy } from 'lodash'
import React, { FC, useEffect, useMemo, useState } from 'react'
import { compile } from '../../../../utils/search'

interface Props {
  teamIdList: number[]
  callbackTeams: (teams: { id: number, name: string }[]) => void
  teamList: { id: number, name: string }[]
  isClear?: boolean
}

const AddTeamModule: FC<Props> = (props) => {
  const {
    teamIdList,
    callbackTeams,
    teamList,
    isClear,
  } = props

  const [isSearchDisplay, setIsSearchDisplay] = useState(false)
  const [selectTeams, setSelectTeams] = useState<{id: number, name: string}[]>([])

  const [teams, setTeams] = useState<{id: number, name: string}[]>([])
  const [searchTeamWord, setSearchTeamWord] = useState<string>("")

  const teamsInit = useMemo(() => (
    teamList || []
  ), [teamList])

  const getUniqueValues = ([...array]) => (
    array.filter((value, _index, self) => self.indexOf(value) === self.lastIndexOf(value))
  )

  const clickTeam = (team_id: number) => {
    if (selectTeams.map((v) => v.id).includes(team_id)) {
      setSelectTeams(selectTeams.filter((v) => v.id !== team_id))
    } else {
      setSelectTeams([...selectTeams, { id: team_id, name: teams.find((v) => v.id === team_id)?.name || "" }])
    }
  }

  const searchTeam = (words: string) => {
    setSearchTeamWord(words)
    if (!words) {
      setTeams([...teamsInit])
      return
    }
    const word = words.toLowerCase().split(/\s+/)
    const list = teamsInit.filter((team) => {
      if (team === null) return false
      return (compile(word).test(team.name.toLowerCase())) || selectTeams.map((v) => v.id).includes(team.id)
    })
    setTeams(sortBy(list, 'id'))
  }

  const resetTeam = () => {
    setSearchTeamWord("")
    setTeams([...teamsInit])
  }

  const openSearch = () => {
    setIsSearchDisplay(true)
  }

  const closeSearch = () => {
    setIsSearchDisplay(false)
    resetTeam()
    if (!getUniqueValues([...selectTeams.map((v) => v.id), ...teamIdList]).length) return
    callbackTeams(selectTeams)
  }

  useEffect(() => {
    setTeams(teamList || [])
  }, [teamList])

  useEffect(() => {
    if (!teams) return
    setSelectTeams(teams.filter((v) => teamIdList.includes(v.id)))
  }, [teamIdList, teams])

  useEffect(() => {
    if (!isClear) return
    setSelectTeams([])
  }, [isClear])

  return (
    <>
      <div
        className="add_button"
        onClick={() => openSearch()}
        role="none"
        style={{
          padding: "4px 8px",
        }}
      >
        <FontAwesomeIcon icon={['fas', 'plus']} />
        &nbsp;
        追加
        <div className={`search_box ${isSearchDisplay || 'none'}`}>
          <div className="search_detail">
            <div className="category">
              <div className="category_title">
                チーム
                {
                  selectTeams.length ? (
                    <div
                      className="select_reset"
                      role="none"
                      onClick={() => setSelectTeams([])}
                    >
                      リセット
                    </div>
                  ) : (
                    <></>
                  )
                }
              </div>
              <div className="search_area">
                <FontAwesomeIcon
                  icon={['fas', 'search']}
                  className="icon"
                />
                <input
                  type="text"
                  placeholder="チームを検索"
                  onChange={(event) => searchTeam(event.target.value)}
                  value={searchTeamWord}
                />
                {
                  searchTeamWord && (
                    <button type="button" className="reset" onClick={resetTeam}>
                      <FontAwesomeIcon icon={['far', 'times-circle']} />
                    </button>
                  )
                }
              </div>
              {
                teams.map((team) => (
                  <button
                    type="button"
                    className={`chip ${selectTeams.map((v) => v.id).includes(team.id) ? "checked" : ""}`}
                    key={`team_${team.id}`}
                    onClick={() => clickTeam(team.id)}
                  >
                    {team.name}
                  </button>
                ))
              }
            </div>
          </div>
        </div>
      </div>
      <div className={`close_screen ${isSearchDisplay || 'none'}`} role="presentation" onClick={() => closeSearch()} />
    </>
  )
}

AddTeamModule.defaultProps = {
  isClear: false,
}

export default AddTeamModule
